export enum Actions {
  REGISTER_STUDENT = 'REGISTER_STUDENT',
  REMOVE_STUDENT = 'REMOVE_STUDENT',
  RESERVE_ROOM = 'RESERVE_ROOM',
  DELETE_ROOM = 'DELETE_ROOM',
  UPDATE_ROOM = 'UPDATE_ROOM',
  HIDE_ROOM = 'HIDE_ROOM',
  ADMIN_STUDENT_ADD = 'ADMIN_STUDENT_ADD',
  ADMIN_STUDENT_EDIT = 'ADMIN_STUDENT_EDIT',
  ADMIN_STUDENT_REMOVE = 'ADMIN_STUDENT_REMOVE'
}

export enum SingleActions {
  FETCH_ALL_ROOMS = 'FETCH_ALL_ROOMS',
  CREATE_ROOM = 'CREATE_ROOM',
  FETCH_ALL_ADMINS = 'FETCH_ALL_ADMINS',
  UPDATE_CONFIG = 'UPDATE_CONFIG',
  FETCH_CONFIG = 'FETCH_CONFIG'
}
